// import React from "react";
// import image1 from "../../assets/about1.png";
// import image2 from "../../assets/about2.png";
// import image3 from "../../assets/about3.jpg";
// import image4 from "../../assets/about4.png";
// import image5 from "../../assets/about5.png";
// import { motion } from "framer-motion";
// export default function AboutUSDesktop() {
//     const events = [
//         {
//             title: "1998: A Vision Takes Root",
//             subtitle: "The Humble Beginnings of Jabal Amel Nurseries",
//             description:
//                 "Hussein Tarhini, the visionary founder of Jabal Amel Nurseries, grew up in a farming family surrounded by prickly pears and olive trees. This early connection to nature inspired a lifelong commitment to revolutionizing agriculture in South Lebanon.",
//             image: image1,
//         },
//         {
//             title: "The First Steps",
//             subtitle: "A Growing Vision from Humble Beginnings",
//             description:
//                 "Hussein began his journey selling prickly pears on a wooden cart in bustling souks. His passion and dedication soon led him to expand his offerings to include a variety of local plants.",
//             image: image2,
//         },
//         {
//             title: "The Foundation is Laid",
//             subtitle: "Jabal Amel’s First Branch in Ebba",
//             description:
//                 "In 1998, the first Jabal Amel Nursery branch was established in Ebba, South Lebanon. Starting as a modest shop, it became a hub for local plants and flowers, marking the beginning of an inspiring journey.",
//             image: image3,
//         },
//         {
//             title: "Branching Out",
//             subtitle: "Expansion and International Reach",
//             description:
//                 "By 1994, a second branch was established in Zefta, South Lebanon. The business flourished, growing to produce, import, and export a wide variety of plants and trees, serving customers locally and globally.",
//             image: image4,
//         },
//         {
//             title: "A Flourishing Legacy",
//             subtitle: "Pioneers in Landscaping and Plant Merchandise",
//             description:
//                 "Today, Jabal Amel Nurseries stands as a leader in landscape design and plant merchandise, achieving remarkable success while staying true to its roots of fostering growth and innovation in agriculture.",
//             image: image5,
//         },
//     ];

//     return (
//         <div style={{ padding: "5%" }}>
//         {events.map((event, index) => (
//             <motion.div
//                 key={index}
//                 initial={{ scale: 0.9, opacity: 0 }}
//                 animate={{ scale: 1, opacity: 1 }}
//                 transition={{ duration: 0.8 }}
//                 // whileHover={{
//                 //     scale: 1.05,
//                 //     boxShadow: "0px 10px 20px rgba(0,0,0,0.2)",
//                 // }}
//                 style={{
//                     display: "flex",
//                     flexDirection: index % 2 === 0 ? "row" : "row-reverse",
//                     alignItems: "center",
//                     marginBottom: "40px",
//                     gap: "40px",
//                 }}
//             >
//                 <div style={{ flex: "1" }}>
//                     <motion.img
//                         src={event.image}
//                         alt={event.title}
//                         style={{
//                             width: "90%",
//                             height: "90%",
//                             objectFit: "cover",
//                             borderRadius: "25% 51% 37% 85% / 40% 40% 37% 40%",
//                         }}
//                         whileHover={{ scale: 1.1,  boxShadow: "0px 10px 20px rgba(0,0,0,0.2)", }}
//                     />
//                 </div>
//                 <div style={{ flex: "1" }}>
//                     <h1 style={{ color: "#1B4D3E", fontFamily: "Montserrat" }}>
//                         {event.title}
//                     </h1>
//                     <h2 style={{ color: "#00674b", fontFamily: "Montserrat" }}>
//                         {event.subtitle}
//                     </h2>
//                     <p
//                         style={{
//                             lineHeight: "1.6",
//                             color: "#18453B",
//                             fontFamily: "Century Gothic",
//                             fontSize: "17px",
//                         }}
//                     >
//                         {event.description}
//                     </p>
//                 </div>
//             </motion.div>
//         ))}
//     </div>
// );
// }


import React from "react";
import Slider from "react-slick";
import { motion } from "framer-motion";
import image1 from "../../assets/about1.png";
import image2 from "../../assets/about2.png";
import image3 from "../../assets/about3.jpg";
import image4 from "../../assets/about4.png";
import image5 from "../../assets/about5.png";
import "./about.css"
import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";

export default function AboutUSDesktop() {
    const events = [
        {
            title: "1998: A Vision Takes Root",
            subtitle: "The Humble Beginnings of Jabal Amel Nurseries",
            description:
                "Hussein Tarhini, the visionary founder of Jabal Amel Nurseries, grew up in a farming family surrounded by prickly pears and olive trees. This early connection to nature inspired a lifelong commitment to revolutionizing agriculture in South Lebanon.",
            image: image1,
        },
      
    ];

    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 4000,
        arrows: false,
        marginTop:"2rem"
    };
    const navigate = useNavigate()
    return (
          <div className="about-us-section"  id="about">
           
            <div className="carousel-container" style={{paddingTop:"5%"}}>
                <h2 className="about-us-title" style={{ fontSize: '1.5rem' }}>About Us</h2>

                {events.map((event, index) => (
                    <motion.div
                        key={index}
                        initial={{ opacity: 0 }}
                        whileInView={{ opacity: 1 }}
                        transition={{ duration: 0.5 }}
                        className="carousel-slide"
                        style={{ marginBottom: "3rem" }}
                    >
                        <div
                            style={{ display: "flex", flexWrap: "wrap", gap: "1.5rem" }}
                            className={`slide-content ${index % 2 === 0 ? "row-normal" : "row-reverse"}`}
                        >
                            <motion.img
                                src={event.image}
                                alt={event.title}
                                className="slide-image"
                                whileHover={{
                                    scale: 1.05,
                                    boxShadow: "0px 10px 20px rgba(0,0,0,0.2)",
                                }}
                                style={{ width: "30%", minWidth: "300px", objectFit: "cover" }}
                            />
                            <div className="slide-text" style={{ flex: 1 }}>
                                <h1 className="slide-title" style={{ fontSize: "1rem" }}>{event.title}</h1>
                                <h2 className="slide-subtitle" style={{ fontSize: "1rem" }}>{event.subtitle}</h2>
                                <p className="slide-description">{event.description}</p>
                                <Button onClick={() => navigate("/details")} variant="contained" sx={{ backgroundColor: "#CC5500", color: "white" }}> Read More</Button>
                            </div>
                        </div>
                    </motion.div>
                ))}
            </div>
        </div>
    );
}
